/*
 * navLink strips the filled hover/active background Mantine paints on NavLink so
 * the sidenav reads as flat text, and leans on weight instead of a colored
 * pill to mark the current page: the active item bolds (the weight cascades from
 * root to the label) while keeping the default text color.
 */
.root {
  &:hover {
    background-color: transparent;
  }

  &[data-active],
  &[data-active]:hover {
    font-weight: 700;
    background-color: transparent;
  }
}
